import { render, staticRenderFns } from "./AssignmentFollowUps.vue?vue&type=template&id=345fb69f&scoped=true&"
import script from "./AssignmentFollowUps.vue?vue&type=script&lang=ts&"
export * from "./AssignmentFollowUps.vue?vue&type=script&lang=ts&"
import style0 from "./AssignmentFollowUps.vue?vue&type=style&index=0&id=345fb69f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345fb69f",
  null
  
)

export default component.exports